/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import completed shot description jobs into your project." |
*
* @param {Scene_Description_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_description = /** @type {((inputs?: Scene_Description_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importez les descriptions de plans terminées dans votre projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren Sie abgeschlossene Shot-Beschreibungsaufträge in Ihr Projekt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa i lavori di descrizione delle riprese completati nel tuo progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте завершенные задания по описанию кадров в свой проект.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importa los trabajos de descripción de tomas completados a tu proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将已完成的镜头描述任务导入到您的项目中。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完了した撮影説明ジョブをプロジェクトにインポートします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण हो चुके शॉट विवरण कार्यों को अपने प्रोजेक्ट में आयात करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe as descrições de planos concluídas para o seu projeto.")
	return /** @type {LocalizedString} */ ("Import completed shot description jobs into your project.")
});